var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiHeadingSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.142,
    height: 4.977,
    viewBox: "0 0 61.142 4.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_heading_separator",
    d: "M37.807,313.784v2.868l61.142,1.012v-4.977Z",
    transform: "translate(98.949 317.665) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiHeadingSeparator);
export default __webpack_public_path__ + "static/media/UI_heading_separator.6bd109b679bb101911a0f728a1eebf75.svg";
export { ForwardRef as ReactComponent };